import { render, staticRenderFns } from "./SortInspector.vue?vue&type=template&id=6fcf64cc&scoped=true&"
import script from "./SortInspector.vue?vue&type=script&lang=js&"
export * from "./SortInspector.vue?vue&type=script&lang=js&"
import style0 from "./SortInspector.vue?vue&type=style&index=0&id=6fcf64cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf64cc",
  null
  
)

export default component.exports